module.exports = __webpack_public_path__ + "static/media/scene7_sama2.4103ff6d.wav";